import React from 'react';
import { Tab } from 'semantic-ui-react';
import '../../assets/css/utils.css';
import Welcome from './Welcome.js';
import How2use from './How2use.js';
import ProjectH from './ProjectH.js';
import SearchInicio from './SearchInicio.js';

const panes = [
  {
    menuItem: 'Bienvenida',
    pane: (
      <Tab.Pane key={1}>
        <Welcome/>
      </Tab.Pane>
    )
  },
  {
    menuItem: 'Consulta',
    pane: (
      <Tab.Pane key={2}>
        <SearchInicio/>
      </Tab.Pane>
    )
  },
  {
    menuItem: '¿Cómo usar HARTA?',
    pane: (
      <Tab.Pane key={3}>
        <How2use/>
      </Tab.Pane>
    )
  },
  {
    menuItem: 'Proyecto HARTA',
    pane: (
      <Tab.Pane key={4}>
        <ProjectH/>
      </Tab.Pane>
    )
  }
];

class Home extends React.Component { 
  render() {
    return (
      <Tab
        panes={panes}
        onTabChange={this.handleChange}
        renderActiveOnly={false}
      />
    );
  }
}

export default Home;